import { z } from 'zod';
export const WalletSchema = z.object({
    id: z.string(),
    userId: z.string(),
    balanceCents: z.number().int().min(0),
    currency: z.string().default('TND'),
    updatedAt: z.date(),
});
export const WalletTopupSchema = z.object({
    provider: z.enum(['D17', 'PAYMEE', 'FLOUCI', 'MOCK']),
    amountCents: z.number().int().min(1000, 'Montant minimum 1 TND'),
});
